import React from "react";

function Sidebar({ onRequestsClick, urgentCount, isCMPAdmin, activeView, onNavClick }) {
  const item = (view, icon, label, badge) => (
    <div
      onClick={() => onNavClick(view)}
      style={{
        display: "flex", alignItems: "center", gap: "10px", padding: "8px 10px",
        fontSize: "12px", fontWeight: 500, borderRadius: "6px", cursor: "pointer",
        marginBottom: "2px",
        background: activeView === view ? "#18073a" : "transparent",
        color: activeView === view ? "#fff" : "#4d4777"
      }}
    >
      <div style={{ width: "20px", height: "20px", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", background: activeView === view ? "rgba(255,255,255,0.15)" : "#f0f0ef" }}>
        {icon}
      </div>
      {label}
      {badge > 0 && (
        <span style={{ marginLeft: "auto", background: "#82162d", color: "#fff", fontSize: "9px", fontWeight: 700, padding: "2px 6px", borderRadius: "10px" }}>
          {badge}
        </span>
      )}
    </div>
  );

  return (
    <div style={{ width: "216px", background: "#fff", borderRight: "0.5px solid #e0e0df", padding: "20px 10px", flexShrink: 0 }}>
      <div style={{ fontSize: "9px", fontWeight: 700, color: "#b0adc8", letterSpacing: "0.1em", textTransform: "uppercase", padding: "0 10px", marginBottom: "6px" }}>Menu</div>
      {item("myContractors", "◈", "My Contractors", urgentCount)}
      {item("myRequests", "↗", "My Requests")}
      {isCMPAdmin && (
        <>
          <div style={{ fontSize: "9px", fontWeight: 700, color: "#b0adc8", letterSpacing: "0.1em", textTransform: "uppercase", padding: "0 10px", margin: "16px 0 6px" }}>Admin</div>
          {item("allContractors", "◫", "All Contractors")}
        </>
      )}
    </div>
  );
}

export default Sidebar;